
window.onload = (event) => {
    console.log('La page est complètement chargée');

    //Import system and start
    import("./Index.jsx").then((module) => {
        console.log('APP Loaded');
        module.default();
    });
};